import React from "react";
import Disclaimer from "../../shared/footer/disclaimer";
import FloorplanPdf from "./FloorplanPdf";
import _ from "lodash";

const FloorplansV2 = (props) => {
  let listing;

  listing = props.listing;

  let agents = () => {
    let agentLength = listing.agents.length;

    let agent = listing.agents.slice(0, 4).map((f, i) => {
      if (agentLength === 1 || (agentLength === 2 && i === 0)) {
        return (
          <li className="agentbold" key={i}>
            {f.name}
          </li>
        );
      } else if (agentLength === i + 1) {
        return <li className="agentbold" key={i}>{`and ${f.name}`}</li>;
      } else {
        return <li className="agentbold" key={i}>{`${f.name},`}</li>;
      }
    });

    return (
      <ul>
        <li className="presented-by">PRESENTED BY:</li>
        {agent}
      </ul>
    );
  };

  const url = () => {
    if (
      listing.status &&
      ["rented", "sold"].includes(listing.status.toLowerCase())
    ) {
      return `sothebysrealty.com/eng/sold/detail/180-l-85298-${listing.listingNumber}`.toUpperCase();
    }
    return listing.rfgid
      ? `SOTHEBYSREALTY.COM/id/` + listing.rfgid.toUpperCase()
      : listing.mls
      ? `SOTHEBYSREALTY.COM/id/` + listing.mls.toUpperCase()
      : "";
  };

  // adding orderNo to keep track of display order
  const orderedFloorplans = listing.floorplans.map((fp, i) => {
    return { ...fp, orderNo: i + 1 };
  });
  // separating floorplan images and floorplan pdfs
  const allFloorplans = _.partition(
    orderedFloorplans,
    (item) => !item.src.includes("pdf")
  );

  const floorplanPdfs = allFloorplans[1].map((item, index) => {
    const content = (
      <FloorplanPdf
        pdfFile={item}
        url={url}
        listing={listing}
        index={index}
        agents={agents}
      />
    );
    return { orderNo: item.orderNo, element: content };
  });

  const floorplanImages = allFloorplans[0].map((item, index) => {
    const content = (
      <div id="print-floorplans" className="page-break" key={index}>
        <div className="floorplan-header">
          <div className="print-vanity-website">
            {listing.vanityDomain ? listing.vanityDomain.toUpperCase() : url()}
          </div>
          <div className="print-view-spacer">
            <hr className="left"></hr>
          </div>
        </div>
        <div className="floorplans" key={index}>
          <img alt={`floorplan view ${index + 1}`} src={item.src} />
        </div>
        <div className="floorplan-footer">
          <div className="floorplan-agents">{agents()}</div>
          <div className="floorplans-disclaimer">
            <Disclaimer />
          </div>
        </div>
      </div>
    );
    return { orderNo: item.orderNo, element: content };
  });
  const sortedFloorplans = _.orderBy(
    [...floorplanImages, ...floorplanPdfs],
    "orderNo",
    "asc"
  ).map((fp) => fp.element);
  return listing.floorplans.length > 0 ? <div>{sortedFloorplans}</div> : null;
};

export default FloorplansV2;



// WEBPACK FOOTER //
// ./src/components/listing-detail/print/floorplanv2.js